import { useLayoutEffect } from "react";
import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Navigate,
  Outlet,
  Route,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";

import RootLayout from "../layout/RootLayout";
import ProfileLayout from "../layout/ProfileLayout";
import HomeLayout from "../layout/HomeLayout";

import Home from "../pages/home/Home";
import StoreMenu from "../pages/storeMenu/StoreMenu";
import About from "../pages/about/About";
import Menu from "../pages/menu";
import Checkout from "../pages/checkout";
import TrackFood from "../pages/trackfood";
import Confirm from "../pages/confirm";
import Payment from "../pages/payment";
import PaymentProcess from "../pages/paymentprocess";
import Login from "../pages/auth/Login";
import Profile from "../pages/profile/Profile";
import PageNotFound from "../PageNotFound";

import MotionWrapper from "../components/Animation/MotionWrapper";
import ErrorFallBack from "../ErrorFallBack";
import Address from "../pages/profile/Address";
import Bookmarks from "../pages/profile/Bookmarks";
import BankTab from "../pages/profile/BankTab";
import PastOrders from "../pages/profile/PastOrders";
import Rewards from "../pages/profile/Rewards";
import Preference from "../pages/profile/Preference";
import Wallet from "../pages/profile/WalletTab";


import {
  setBasicDineData,
  setHomeLoader,
  setLocationData,
} from "../store/basicData/basicDataSlice";
import { setUserAddress, setUserData } from "../store/userData/userDataSlice";

import { getBasicDineData } from "../services";
import { getDineConfigSession, setCartConfigSession } from "../utils";

import useSetupGAnalytics from "../hooks/useSetupGAnalytics";
import useSetupFAnalytics from "../hooks/useSetupFAnalytics";
import PrivateRoute from "./PrivateRoute";

const withMotion = (Component) => (
  <MotionWrapper>
    <Component />
  </MotionWrapper>
);

const logError = (error, info) => {
  console.error("Error caught by boundary:", error, info);
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Navigate to="/home" replace />} />

      <Route
        path="/"
        element={
          <ErrorBoundary FallbackComponent={ErrorFallBack} onError={logError}>
            <RootLayout />
          </ErrorBoundary>
        }
      >
        {/* <Route
          index
          element={
            <MotionWrapper>
              <Home />
            </MotionWrapper>
          }
        /> */}
        <Route path="storemenu">
          {/* <Route path=":id" element={<Outlet />}>
            <Route path=":id" element={<Outlet />}> */}
          <Route
            index
            element={
              // <MotionWrapper>
              <StoreMenu />
              // </MotionWrapper>
            }
          />
          {/* </Route>
          </Route> */}
        </Route>

        <Route path="store" element={<PrivateRoute element={<Outlet />} />}>
          <Route
            path="cart"
            element={<PrivateRoute element={<Checkout />} />}
          />
          <Route
            path="payment"
            element={<PrivateRoute element={<Payment />} />}
          />

          <Route
            path="orderstatus"
            element={<PrivateRoute element={<Outlet />} />}
          >
            <Route path=":id" element={<PrivateRoute element={<Outlet />} />}>
              <Route index element={<PrivateRoute element={<TrackFood />} />} />
            </Route>
          </Route>
          <Route path="confirm" element={<PrivateRoute element={<Outlet />} />}>
            <Route path=":id" element={<PrivateRoute element={<Outlet />} />}>
              <Route index element={<PrivateRoute element={<Confirm />} />} />
            </Route>
          </Route>

          <Route
            path="paymentprocessing"
            element={<PrivateRoute element={<Outlet />} />}
          >
            <Route path=":id1" element={<PrivateRoute element={<Outlet />} />}>
              <Route
                path=":id2"
                element={<PrivateRoute element={<Outlet />} />}
              >
                <Route
                  path=":id3"
                  element={<PrivateRoute element={<Outlet />} />}
                >
                  <Route
                    index
                    element={<PrivateRoute element={<PaymentProcess />} />}
                  />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>

        <Route
          path="store/about"
          element={
            <MotionWrapper>
              <About />
            </MotionWrapper>
          }
        />
        {/* <Route
          path="profile"
          element={
            <MotionWrapper>
              <Profile />
            </MotionWrapper>
          }
        /> */}

        <Route
          path="profile"
          element={<PrivateRoute element={<ProfileLayout />} />}
        >
          <Route index element={<PrivateRoute element={<Profile />} />} />

          <Route
            path="address"
            element={<PrivateRoute element={<Address />} />}
          />
          <Route
            path="bookmarks"
            element={<PrivateRoute element={<Bookmarks />} />}
          />
          <Route
            path="bankcards"
            element={<PrivateRoute element={<BankTab />} />}
          />
          <Route
            path="past-orders"
            element={<PrivateRoute element={<PastOrders />} />}
          />
          <Route
            path="rewards"
            element={<PrivateRoute element={<Rewards />} />}
          />
          <Route
            path="preference"
            element={<PrivateRoute element={<Preference />} />}
          />
          <Route
            path="wallet"
            element={<PrivateRoute element={<Wallet />} />}
          />
        </Route>

        {/* <Route path="home" element={<Outlet />}> */}
        <Route path="stores" element={<Outlet />}>
          <Route
            path="paymentprocessing/:id1/:id2/:id3"
            element={<PaymentProcess />}
          />
        </Route>
      </Route>
      <Route
        index
        element={
          <MotionWrapper>
            <Home />
          </MotionWrapper>
        }
      />
      <Route path="/login" element={withMotion(Login)} />
      <Route
        path="/registration"
        element={withMotion(
          <>
            <Login />
            <Login />
          </>
        )}
      />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  )
);

const RoutePaths = () => {
  const dispatch = useDispatch();
  const setupGAnalytics = useSetupGAnalytics();
  const setupFAnalytics = useSetupFAnalytics();

  useLayoutEffect(() => {
    (async () => {
      const { status, data } = await getBasicDineData();
      if (status === 200) {
        dispatch(setHomeLoader(false));

        setCartConfigSession(
          data?.cartConfig ?? {
            pos_basket_Delivery_Type: "Collection",
            pos_basket_Payment_Type: "Card",
            pos_basket_Id: 0,
          }
        );

        if (data?.customer?.length) {
          dispatch(setUserData(data.customer));
        }

        if (data?.customer?.common_customer_Address?.length) {
          dispatch(
            setUserAddress({
              selected: data.customer.common_customer_Address[0],
              address: data.customer.common_customer_Address,
            })
          );
        }

        dispatch(setBasicDineData(data));

        dispatch(
          setLocationData(
            getDineConfigSession()?.locationData ?? {
              latitude: "53.048988",
              longitude: "-2.198013",
              cityName: "Stoke-on-trent",
              street: "Scotia Road",
              county: "",
              frm: "addr",
              postcodePretty: "st6 4ep",
            }
          )
        );

        setupGAnalytics(data);
        setupFAnalytics(data);
      }
    })();
  }, []);

  return <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />;
};

export default RoutePaths;
